import React, { Component } from 'react'
import {
  Row,
  Col,
  Form,
  Button,
  // OverlayTrigger,
  // Tooltip,
  Modal,
  ModalTitle,
} from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import { i18nTranslate } from 'src/utils'
import {
  PriceSubscription,
  SubscriptionQuantityDropdown,
  Icons,
  ConfirmationModal,
  LinkWithLocale,
  SubscriptionDropDown,
} from 'src/views/components'
import { subscriptionContainer, cartContainer } from 'src/models'
import { getFrequencyList, dateFormatDeps } from 'src/deps'
import { getConvertedMonth } from 'src/utils'
import { transformShowAllResponse } from './deps'

const modalMessage = i18nTranslate(
  'mysubscriptions.deleteProducts',
  'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
)

@observer
class ShowAllProductListView extends Component {
  @observable enableConfirmation = false
  @observable removeItemSubscription = false
  @observable isDeleteModalEnabled = false
  @observable selectedSubscriptionId = ''
  transformedSubscriptionData = []

  handleFrequencyChange = async (value, product) => {
    const { handleFrequencyChange } = this.props
    if (typeof handleFrequencyChange == 'function') {
      return await handleFrequencyChange(product, value)
    }
    return false
  }

  handleQuantityChange = async (count, product) => {
    const { handleQuantityChange } = this.props
    if (typeof handleQuantityChange == 'function') {
      return await handleQuantityChange(product, count)
    }
    return false
  }

  handleCancelDelete = () => {
    this.enableConfirmation = false
    this.removeItemSubscription = false
    this.selectedSubscriptionId = ''
  }

  handleConfirmDelete = async () => {
    const { handleMultipleProductsDelete } = this.props
    this.enableConfirmation = false
    if (typeof handleMultipleProductsDelete == 'function') {
      await handleMultipleProductsDelete()
    }
  }
  handleItemConfirmation = async () => {
    const { handleItemProcessing } = this.props
    this.removeItemSubscription = false
    const data = { id: this.selectedSubscriptionId }
    handleItemProcessing &&
      handleItemProcessing(data, this.handleSkipDisableCondition)
    this.selectedSubscriptionId = ''
  }
  handleDeleteAllItems = () => {
    const productStr = []
    let remainArray = []
    if (subscriptionContainer.selectedSubscriptionProducts.size != 0) {
      subscriptionContainer.selectedSubscriptionProducts.forEach(productId => {
        return productStr.push(productId)
      })
      remainArray = this.transformedSubscriptionData.filter(item => {
        return !productStr.includes(item.id)
      })
    }
    let hasOneTime =
      remainArray.some(data => data?.type === 'VARIABLE_SINGLE_ORDER') || false
    let hasMultiTime =
      remainArray.some(data => data?.type === 'VARIABLE_MULTI_ORDER') || false
    if (remainArray.length === 0 || hasMultiTime) {
      this.enableConfirmation = true
    } else {
      this.isDeleteModalEnabled = true
    }
    // this.enableConfirmation = true
  }
  handleItemProcessing = itemId => {
    this.selectedSubscriptionId = itemId
    this.removeItemSubscription = true
  }
  handleProductDeleteCheckbox = itemId => {
    // to handle single product select/deselect scenario
    if (subscriptionContainer.selectedSubscriptionProducts.has(itemId)) {
      subscriptionContainer.selectedSubscriptionProducts.delete(itemId)
    } else {
      subscriptionContainer.selectedSubscriptionProducts.add(itemId)
    }
  }

  handleDeleteAllCheckbox = isCurrentMonthProcessedAndNotSuccessYet => {
    // to select/deselect all product in subscription
    if (subscriptionContainer.selectedSubscriptionProducts?.size) {
      // if selectedSubscriptionProducts has products already, then it must be deselected onClick
      subscriptionContainer.selectedSubscriptionProducts?.clear()
    } else {
      // if there are no products in selectedSubscriptionProducts,
      // then on selecting checkBox, all products must be added to selectedSubscriptionProducts
      this.transformedSubscriptionData.forEach(item => {
        const itemId = item?.id || 0
        const isCurrentMonthProduct = item?.isCurrentMonthProduct || false
        if (isCurrentMonthProcessedAndNotSuccessYet) {
          if (!isCurrentMonthProduct) {
            subscriptionContainer.selectedSubscriptionProducts?.add(itemId)
          }
        } else {
          subscriptionContainer.selectedSubscriptionProducts?.add(itemId)
        }
      })
    }
  }

  renderProductDetailsHeader = isCurrentMonthProcessedAndNotSuccessYet => {
    const { isDeleteAllCallInProgress = false } = this.props
    const subscriptionItemsCount = this.transformedSubscriptionData.length
    const selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts.size
    const isToSelectDeleteAll = selectedProductCount != 0 ? true : false

    //CX121-4791 - Google Translate
    const modalTitle =
      subscriptionItemsCount == selectedProductCount
        ? i18nTranslate(
            'subscription.deleteAllTitle',
            'Delete All Subscriptions'
          )
        : selectedProductCount == 1
        ? `${i18nTranslate('catalog.Delete', 'Delete', {
            nameSpace: 'ssr-resource',
          })} ${selectedProductCount} ${i18nTranslate('catalog.Item', 'item', {
            nameSpace: 'ssr-resource',
          })} ?`
        : `${i18nTranslate('catalog.Delete', 'Delete', {
            nameSpace: 'ssr-resource',
          })} ${selectedProductCount} ${i18nTranslate(
            'catalog.Items',
            'items',
            {
              nameSpace: 'ssr-resource',
            }
          )} ?`
    const ariaLabel =
      selectedProductCount === subscriptionItemsCount
        ? i18nTranslate('subscription.deleteAll', 'Delete all products')
        : i18nTranslate(
            'subscription.deleteSelected',
            'Delete selected products'
          )
    return (
      <div className="product-title-row py-3 d-flex" role="row">
        {!subscriptionContainer.allUsers && (
          <div className="delete-col d-flex pl-3" role="columnheader">
            <Form.Check
              className="subs-delete-product-checkbox "
              id="subs-delete-product-checkbox"
              custom
              checked={isToSelectDeleteAll}
              label={
                <span className="sr-only">
                  {i18nTranslate(
                    'subscription.showAllDeleteCheckbox',
                    'Delete Multiple Product'
                  )}
                </span>
              }
              onChange={() => {
                this.handleDeleteAllCheckbox(
                  isCurrentMonthProcessedAndNotSuccessYet
                )
              }}
              disabled={isCurrentMonthProcessedAndNotSuccessYet}
            />
            <Button
              aria-label={ariaLabel}
              tabIndex={0}
              variant="transparent"
              className="sbs-delete-selected-btn delete-all-button shadow-none rounded-0 p-0 primary-button "
              onClick={this.handleDeleteAllItems}
              disabled={!isToSelectDeleteAll || isDeleteAllCallInProgress}
              data-testid="qa-user-subs-all-product-delete">
              <Icons
                name="CRUD"
                icontype="delete"
                customicon="Delete"
                width="20px"
                alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
                fill="#3a3a3a"
              />
            </Button>
            {this.enableConfirmation && (
              <ConfirmationModal
                showConfirmationModal={this.enableConfirmation}
                handleConfirm={this.handleConfirmDelete}
                handleCancel={this.handleCancelDelete}
                handleHide={this.handleCancelDelete}
                modalMessage={modalMessage}
                renderText={modalTitle}
              />
            )}
            {this.removeItemSubscription && (
              <ConfirmationModal
                showConfirmationModal={this.removeItemSubscription}
                handleConfirm={this.handleItemConfirmation}
                handleCancel={this.handleCancelDelete}
                handleHide={this.handleCancelDelete}
                modalMessage={`Removal will associate the Shipping Method/Shipping Address/Payment Method at Subscription level`}
                renderText={i18nTranslate(
                  'confirm.continueMessage',
                  'Do you want to continue ?'
                )} //CX121-4791 - Google Translate
                confirmButtonText={i18nTranslate('subscription.yes', 'YES')}
                cancelButtonText={i18nTranslate('subscription.no', 'NO')}
              />
            )}
          </div>
        )}
        <div
          className="sbs-list-header-menu sbs-title text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('subscriptionsAllHeader.product', 'product')}
        </div>
        <div
          className="sbs-list-header-menu text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('subscriptionsAllHeader.ships', 'ships on')}
        </div>
        <div
          className="sbs-list-header-menu subscription-frequency-header text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('subscriptionsAllHeader.frequency', 'frequency')}
        </div>
        <div
          className="sbs-list-header-menu text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('subscriptionsAllHeader.quantity', 'quantity')}
        </div>
        <div
          className="sbs-list-header-menu text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('subscriptionsAllHeader.price', 'price')}
        </div>
        <div
          className="sbs-list-header-menu text-uppercase font-weight-bold"
          role="columnheader">
          {i18nTranslate('mysubscriptions.Skipped', 'Skipped')}
        </div>
        {/* <div className="d-flex justify-content-between p-0 product-details-header align-items-center">
          <div className="p-0">
            <span>{i18nTranslate('subscriptionsAllHeader.product', 'Product')}</span>
            <span className="header-ships float-right p-0">
              {i18nTranslate('subscriptionsAllHeader.ships', 'Ships on')}
            </span>
          </div>
          <div className="product-properties d-flex p-0">
            <div className="p-0">
              {i18nTranslate('subscriptionsAllHeader.frequency', 'frequency')}
            </div>
            <div className="quantity-col p-0">
              {i18nTranslate('subscriptionsAllHeader.quantity', 'quantity')}
            </div>
            {/* <div className="p-0" md={2}>
              <Trans i18nKey="subscriptionsAllHeader.pv">pv</Trans>
            </div> */}
        {/* <div className="p-0 subscriptions-header-price">
              {i18nTranslate('subscriptionsAllHeader.price', 'price')}
            </div>
          </div>
        </div> */}
        {/* <div className="items-count-col d-none">
          <span>{subscriptionItemsCount} items</span>
          {selectedProductCount != 0 && (
            <span className="pl-1">({selectedProductCount} selected)</span>
          )}
        </div> */}
      </div>
    )
  }
  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
    } = address
    const actualZip = zipCode || zip
    return (
      <>
        <Col
          className="pr-3 pl-3 m-1 border-left border-right subscription-shipping-addr"
          data-testid="qa-user-sub-shipping-address">
          <Row noGutters className={'align-items-center'}>
            <Col className="col-10 text-uppercase shipping-text">
              {i18nTranslate('subscription.shippingTitle', 'Shipping Address')}
            </Col>
          </Row>
          <p className="subscription-shipping-address">
            {addressLine1 +
              addressLine2 +
              street1 +
              street2 +
              ' ' +
              city +
              ', ' +
              state +
              ', ' +
              actualZip}
            <br />
            {country}
          </p>
        </Col>
      </>
    )
  }
  renderPaymentMethod = (payment = {}, isFromModal = false) => {
    const {
      name = '',
      firstName = '',
      lastName = '',
      cardExpirationYear = '',
      cardExpirationMonth = '',
      expiryYear = '',
      expiryMonth = '',
      paymentType: type = '',
      displayName = '',
      // properties = {},
    } = payment

    /*
     * Temporarily splitting card number into 4 per group
     * TODO: Need to split card number based on card type
     */
    const cardNumber = (payment?.cardNumber || '').replace(
      /^(.{4})(.{4})(.{4})(.*)$/,
      '$1-$2-$3-$4'
    )
    const defaultSelectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const month = this.props?.location?.queryParams?.month || ''
    let selectedMonth = 0
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }
    const totalActiveSubscriptionCount =
      cartContainer?.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount
    const accountNumber = payment?.properties?.accountNumber || ''
    const bankName = payment?.properties?.bankName || ''
    const endingDigits = accountNumber
      ? accountNumber.substr(accountNumber.length - 4)
      : undefined

    return (
      <>
        <Col
          className="p-1 pl-3 m-1 subscription-payment"
          data-testid="qa-user-sub-payment-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              {lastOrderProcessedMonth == selectedMonth &&
                (lastSubscriptionOrderStatus.toLowerCase() ===
                  'payment_failed' ||
                  lastSubscriptionOrderStatus.toLowerCase() ===
                    'order_failed') &&
                totalActiveSubscriptionCount != 0 &&
                month !== 'showall' && (
                  <div className="col-1 warningIcnDiv">
                    <Icons
                      name="product-icon"
                      icontype="danger-warning"
                      className="subscription-wrn-icon"
                      color="#8C6E43"
                    />
                  </div>
                )}
              <Col className="col-9 text-uppercase shipping-text">
                {i18nTranslate('subscription.paymentTitle', 'Payment Method')}
              </Col>
            </Row>
          )}
          {type && type.toLowerCase() === 'ach' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate('subscription.achPayment', 'ACH')}
              <br />
              {bankName}
              <br />
              {endingDigits && (
                <>{`${i18nTranslate(
                  'payment.accountEndingText',
                  'Account ending in'
                )} - ${endingDigits}`}</>
              )}
            </Col>
          ) : type && type.toLowerCase() === 'paypalsubscription' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate(
                'subscription.paypalsubscription',
                'PayPal Account'
              )}
              <br />
              {displayName}
            </Col>
          ) : (
            type &&
            (type?.toLowerCase() === 'creditcard' ||
              type?.toLowerCase() === 'debitcard') && (
              <p className="p-0 text-dark">
                {name != null && `${firstName || name}`}
                {lastName != null && ` ${lastName}`}
                {name != null && lastName != null && <br />}
                {cardNumber}
                <br />
                {`${cardExpirationMonth || expiryMonth}/${
                  cardExpirationYear || expiryYear
                }`}
              </p>
            )
          )}
        </Col>
      </>
    )
  }
  renderShippingMethod = (shipping = {}, isFromModal = false) => {
    const shippingMethods = this.props?.shippingMethods || []
    const selectedShippingMethod = shippingMethods.filter(item => {
      {
        return item?.shippingMethodId || '' == shipping.method
      }
    })
    const shippingMethod = selectedShippingMethod?.length
      ? { ...selectedShippingMethod?.[0] }
      : shipping
    const { method = '', name = '', cost = '0' } = shippingMethod
    const currencySymbol = this.props?.currencySymbol || '$'
    let description = shippingMethod?.description || ''
    const getMonthlyPV =
      subscriptionContainer.subscriptionPreferenceResponse?.order?.monthlyPV ||
      0
    const shippingCost =
      getMonthlyPV >= 100 &&
      (method.toLowerCase() == 'economy' || name.toLowerCase() == 'economy')
        ? i18nTranslate('subscription.free', 'FREE')
        : `${currencySymbol}${cost}`
    const displayDescription =
      description && description.toLowerCase() != 'none'
        ? `- (${description} business days)`
        : `- ${i18nTranslate('subscription.noItemsAdded', 'No Items Added')}`
    return (
      <>
        <Col
          className={`p-1 pl-3 m-1 subscription-shipping`}
          data-testid="qa-user-sub-shipping-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              <Col className="col-10 text-uppercase shipping-text">
                {i18nTranslate(
                  'subscription.shippingMethod',
                  'Shipping Method'
                )}
              </Col>
            </Row>
          )}
          <Col className="p-0 text-dark">
            {method || name ? (
              <>{`${method || name}`}</>
            ) : (
              <>
                {i18nTranslate(
                  'subscription.shippingMethodDescription',
                  'No Shipment This Month'
                )}
              </>
            )}
          </Col>
        </Col>
      </>
    )
  }
  renderProductDetails = (
    subscriptionProduct,
    currentMonth,
    lastOrderProcessedMonth,
    isCurrentMonthSuccess,
    isCurrentMonthProcessedAndNotSuccessYet
  ) => {
    const itemId = subscriptionProduct?.id || ''
    const itemInfo = subscriptionProduct?.itemInfo?.[0] || {}
    const isOnetime =
      subscriptionProduct?.type === 'VARIABLE_SINGLE_ORDER' || false
    const properties = itemInfo?.properties || {}
    const productName = properties?.name || ''
    const skusArray = itemInfo?.skus || ''
    const skuID = skusArray[skusArray.length - 1].id || ''
    let pdtName =
      skusArray?.length > 0
        ? skusArray[skusArray.length - 1]?.skuProperties?.name ||
          skusArray[skusArray.length - 1]?.name
        : productName
    //If bundle / kit
    const bundleObj = skusArray.find(
      obj => obj.type === 'BUNDLE' || obj.type === 'SKUKIT'
    )
    if (bundleObj) {
      pdtName = bundleObj.skuProperties?.name || bundleObj.name
    }

    //const isShipping = get(subscriptionProduct, 'isShipping', false)
    const frequencyPeriod = subscriptionProduct?.frequencyPeriod || ''
    const frequencyType = subscriptionProduct?.frequencyType || ''
    const frequencyOptionList = getFrequencyList(properties)
    const selectedMonth = subscriptionProduct?.selectedMonth || ''
    const selectedFrequencyValue = [frequencyPeriod, frequencyType].join('-')
    const selectedFrequency = frequencyOptionList?.findIndex(
      frequencyOption => frequencyOption?.value === selectedFrequencyValue
    )
    const quantity = itemInfo?.quantity || ''
    const maxPurchaseQuantity = properties?.maxpurchasequantity || 5
    // const pvValue =
    //   get(subscriptionProduct, 'properties.pointValue', '00.00') || '00.00'
    const showAllPrice =
      itemInfo?.totalValue?.priceAfterDiscount || itemInfo?.price || '0'
    const discountedPrice =
      subscriptionProduct?.properties?.priceAfterDiscount || '0'
    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || ''
    const isStarterKit = properties?.isstarterkit || 'false'
    const partNumber = properties?.partnumber || ''
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(showAllPrice),
      discountedPrice: parseFloat(discountedPrice),
    }
    /* const nextOrderCreationDate = get(
      subscriptionProduct,
      'nextOrderCreationDate',
      0
    ) */
    let isSkipped =
      subscriptionProduct?.properties?.isSkipped === 'true' || false
    const paymentInfo = subscriptionProduct?.paymentInfo || {}
    const addressInfo = subscriptionProduct?.addressInfo || {}
    const shippingInfo = subscriptionProduct?.shippingInfo || {}
    const enableItemLevelProcessing = false
    // subscriptionProduct?.enableItemLevelProcessing || false
    const productStatus = itemInfo?.skus?.[0]?.status || ''
    const isSubscription = itemInfo?.properties?.issubscription || ''
    const isProductStatusInactive =
      productStatus == 'INACTIVE' || isSubscription === false
    const stockStatus = (itemInfo?.skus?.[0]?.inventory || '').toLowerCase()
    const isStockError =
      stockStatus == 'out of stock' || stockStatus == 'discontinued'
    // let nextOrderMonth = new Date(nextOrderCreationDate)
    // nextOrderMonth = nextOrderMonth.toLocaleString('default', {
    //   month: 'short',
    // })
    // this is a random date used to get month as string
    // let month = new Date(1995, selectedMonth - 1, 17)
    // const nextOrderMonth = month.toLocaleString('default', {
    //   month: 'short',
    // })
    const productSkuStatus =
      itemInfo?.skus?.[0]?.skuProperties?.productStatus || ''
    const isDiscontinued = isProductStatusInactive
      ? productSkuStatus.toLowerCase?.() === 'discontinued'
      : false
    const nextOrderMonth = dateFormatDeps
      .matchMonthFromNumberToString(selectedMonth)
      .substr(0, 3)
    let isToSelectProduct = false
    if (subscriptionContainer.selectedSubscriptionProducts.has(itemId)) {
      isToSelectProduct = true
    }
    let shouldDisableItemEdit = false // freq and qty
    let shouldDisableItemLevelCheckbox = false
    // if current month is processed and not success yet
    if (
      isCurrentMonthProcessedAndNotSuccessYet &&
      subscriptionProduct.isCurrentMonthProduct
    ) {
      shouldDisableItemEdit = true // freq and qty
      shouldDisableItemLevelCheckbox = true
    }
    if (isProductStatusInactive || isStockError) {
      shouldDisableItemEdit = true // YLUS-5782
    }
    // enable upcoming month product edits only if current month is order_success
    // enable upcoming month checkbox if current month is un processed or success
    /*{
      if (!subscriptionProduct.isCurrentMonthProduct) {
        {
           if (!isCurrentMonthSuccess) {
          shouldDisableItemEdit = true // freq and qty
        }
        }
        if (currentMonth != lastOrderProcessedMonth) {
          shouldDisableItemLevelCheckbox = true
        }
      }
    }*/
    return (
      <div role="rowgroup">
        <div
          className="product-details-cont d-flex w-100 align-items-center py-3"
          role="row"
          key={itemId}>
          {!subscriptionContainer.allUsers && (
            <div className="delete-col d-flex pl-3" role="cell">
              <Form.Check
                className={`subs-delete-product-checkbox`}
                id={`delete-product-checkbox-${itemId}`}
                custom
                label={
                  <span className="sr-only">
                    {i18nTranslate(
                      'subscription.showAllProductCheckbox',
                      'Subscription Product Checkbox'
                    )}
                  </span>
                }
                checked={isToSelectProduct}
                autoComplete="off"
                onChange={() => {
                  this.handleProductDeleteCheckbox(itemId)
                }}
                disabled={shouldDisableItemLevelCheckbox}
                aria-label={pdtName}
              />
            </div>
          )}
          <div
            className="sbs-list-details product-name-wrapper sbs-title"
            role="cell">
            <div>
              <h4 className="product-name p-0">{pdtName}</h4>
              {!bundleObj && skuID != '' && (
                <h6 className="itemno">
                  {i18nTranslate('subscription.itemcode', 'Item')} #{' '}
                  <span>{skuID}</span>
                </h6>
              )}
              {isStockError && (
                <div className="text-danger error-alert-text">
                  {i18nTranslate('subscriptions.outofstock', 'OUT OF STOCK!')}
                </div>
              )}
              {isDiscontinued && (
                <div className="text-danger error-alert-text">
                  {i18nTranslate('Subscription.Discontinued', 'Discontinued')}
                </div>
              )}
              {isProductStatusInactive && !isDiscontinued && (
                <div className="text-danger error-alert-text">
                  {i18nTranslate(
                    'subscriptions.productStatusInactive',
                    'INACTIVE PRODUCT'
                  )}
                </div>
              )}
            </div>
          </div>
          <div
            className="sbs-list-details product-status text-uppercase"
            role="cell">
            {/* <span className="d-md-none item-text-ships">{`${i18nTranslate(
            'subscriptionsAllHeader.ships',
            'Ships'
          )}:`}</span> */}
            {nextOrderMonth}
          </div>

          {/* Hide frequency and quantity dropdowns if the sub is a One-time */}
          {isOnetime ? (
            <>
              <div
                role="cell"
                className="sbs-list-details subscription-frequency-dropdown">
                {i18nTranslate('subscription.oneTime', 'One-time')}
              </div>
              <div
                role="cell"
                className="sbs-list-details subscription-quantity-dropdown">
                {quantity}
              </div>
            </>
          ) : (
            <>
              {/* Frequency Dropdown */}
              <div
                role="cell"
                className={`sbs-list-details subscription-frequency-dropdown ${
                  (shouldDisableItemEdit || isSkipped) && 'disabled'
                }`}>
                <SubscriptionDropDown
                  frequencyPeriod={frequencyPeriod}
                  frequencyType={frequencyType}
                  itemId={itemId}
                  quantity={quantity}
                  handleSubscriptionChange={this.handleFrequencyChange}
                  subscriptionProduct={subscriptionProduct}
                  showAllFrequency={true}
                  disableActions={subscriptionContainer.allUsers}
                />
              </div>

              {/* Quantity Dropdown */}
              <div
                role="cell"
                className={`sbs-list-details subscription-quantity-dropdown ${
                  (shouldDisableItemEdit || isSkipped) && 'disabled'
                }`}>
                <SubscriptionQuantityDropdown
                  quantity={quantity}
                  cartItemId={itemId}
                  maxCartItemLimit={maxPurchaseQuantity}
                  handleCartQuantityChange={count =>
                    this.handleQuantityChange(count, subscriptionProduct)
                  }
                  transCart="viewCart"
                  hasDisabled={subscriptionContainer.allUsers}
                />
              </div>
            </>
          )}

          <div className="sbs-list-details d-flex">
            <PriceSubscription
              classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
              transactionPrice={priceObj}
              isStarterKit={isStarterKit}
              partNumber={partNumber}
            />
          </div>
          <div className="sbs-list-details skipped-status d-flex">
            {isSkipped && (
              <span>{i18nTranslate('mysubscriptions.Skipped', 'Skipped')}</span>
            )}
          </div>
          {/* <div
          className="product-details-row w-100 align-items-center py-3 column-gap-2"
          key={itemId}>
          <div className="product-details d-flex align-items-center">
            <div className="product-name-wrapper d-flex justify-content-between align-items-center p-0">
              <div>
                <h3 className="product-name p-0">{pdtName}</h3>
                {isStockError && (
                  <div className="font-weight-bold text-danger error-alert-text">
                    {i18nTranslate('subscriptions.outofstock', 'OUT OF STOCK!')}
                  </div>
                )}
                {isProductStatusInactive && (
                  <div className="font-weight-bold text-danger error-alert-text">
                    {i18nTranslate(
                      'subscriptions.productStatusInactive',
                      'INACTIVE PRODUCT'
                    )}
                  </div>
                )}
              </div>
              <div className="product-status text-uppercase">
                <span className="d-md-none item-text-ships">{`${i18nTranslate(
                  'subscriptionsAllHeader.ships',
                  'Ships'
                )}:`}</span>
                {nextOrderMonth}
                {/* {isShipping && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 250 }}
                  overlay={
                    <Tooltip
                      id="subscription-ships-tooltip"
                      className="tooltip-message">
                      <Trans i18nKey="mysubscriptions.shipsThisMonth">
                        Ships this month.
                      </Trans>
                    </Tooltip>
                  }>
                  <span>
                    <Icons
                      name="account"
                      icontype="order-history"
                      alt={i18nTranslate('subscription.shipIcon', 'ship icon')}
                      ariaLabel={i18nTranslate('subscription.shipIcon', 'ship icon')}
                      width="20px"
                      color="#3E7957"
                    />
                  </span>
                </OverlayTrigger>
              )} */}
          {/* </div>
            </div>
            <div className="product-properties d-flex align-items-center p-0">
              <div className="p-0">
                <div
                  className={`subscription-frequency-dropdown mr-2 ${
                    shouldDisableItemEdit && 'disabled'
                  }`}>
                  <SubscriptionDropDown
                    frequencyPeriod={frequencyPeriod}
                    frequencyType={frequencyType}
                    itemId={itemId}
                    quantity={quantity}
                    handleSubscriptionChange={this.handleFrequencyChange}
                    subscriptionProduct={subscriptionProduct}
                    showAllFrequency={true}
                    disableActions={subscriptionContainer.allUsers}
                  />
                </div>
              </div>
              <div className="quantity-col d-flex p-0">
                <div
                  className={`subscription-quantity-dropdown ${
                    shouldDisableItemEdit && 'disabled'
                  }`}>
                  <SubscriptionQuantityDropdown
                    quantity={quantity}
                    cartItemId={itemId}
                    maxCartItemLimit={maxPurchaseQuantity}
                    handleCartQuantityChange={count =>
                      this.handleQuantityChange(count, subscriptionProduct)
                    }
                    transCart="viewCart"
                    hasDisabled={subscriptionContainer.allUsers}
                  />
                </div>
              </div> */}
          {/* <Col className="p-0" md={2} xs={6}>
              <span className="subscription-pv-label d-none">
                <Trans i18nKey="subscriptionProdTile.pvValue">PV: </Trans>
              </span>
              <span>{pvValue}</span>
            </Col> */}
          {/* <div className="d-flex price-col p-0">
                <PriceSubscription
                  classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
                  transactionPrice={priceObj}
                  isStarterKit={isStarterKit}
                  partNumber={partNumber}
                />
              </div>
            </div>
          </div> 
        </div> */}
          {/* @todo: need to be fixed once understood requirement */}
          {enableItemLevelProcessing && (
            <div className="w-100 d-flex flex-column ml-4 mr-4 mt-2 mb-2 shipping-container border position-relative">
              <div className="pt-2 flex-column flex-md-row">
                {this.renderPaymentMethod(paymentInfo)}
                {this.renderShippingAddress(addressInfo)}
                {this.renderShippingMethod(shippingInfo)}
              </div>
              <Button
                variant="transparent
      skip-button rounded-0 text-uppercase primary-button position-absolute"
                onClick={() => this.handleItemProcessing(itemId)}
                data-testid="qa-user-sub-product-remove">
                {i18nTranslate('subscriptionProdTile.remove', 'REMOVE')}
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }
  deleteToggleQuickView = () => {
    this.isDeleteModalEnabled = false
  }
  renderDeleteInfoModal = () => {
    return (
      <>
        <Modal
          centered={true}
          show={this.isDeleteModalEnabled}
          className="subscription-dialog"
          dialogClassName="quick-view-dialog"
          onHide={this.deleteToggleQuickView}>
          <Modal.Header className="border-0" closeButton>
            <ModalTitle className="font-weight-bold d-flex m-0">
              <InformationIcon size="1.5rem" className="mr-2" />
              {i18nTranslate('subscription.delete', 'Unable to Delete items')}
            </ModalTitle>
          </Modal.Header>
          <Modal.Body>
            {i18nTranslate(
              'subscription.deleteDetails',
              'At least one subscription item must ship with one time items. To delete subscription items, please remove one-time items from your next shipment.'
            )}
          </Modal.Body>
        </Modal>
      </>
    )
  }

  renderProductListView = () => {
    /* const currentDate = get(
      subscriptionContainer.subscriptionPreferenceResponse,
      'currentDate',
      Date.now()
    ) */
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    // const dateNow = new Date(currentDateInMillis)
    // const currentMonth = dateNow.getMonth() + 1
    // const lastOrderProcessedMonth =
    //   new Date(lastOrderProcessingDate).getMonth() + 1
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const isCurrentMonthSuccess =
      lastOrderProcessedMonth == currentMonth &&
      lastSubscriptionOrderStatus.toLowerCase() == 'order_success'
    const isCurrentMonthProcessedAndNotSuccessYet =
      lastOrderProcessedMonth == currentMonth &&
      lastSubscriptionOrderStatus.toLowerCase() == 'order_created'
    this.transformedSubscriptionData = transformShowAllResponse(
      currentMonth,
      lastOrderProcessedMonth,
      lastSubscriptionOrderStatus,
      subscriptionContainer.showAllSubscriptionResponse,
      false
    )
    const subscriptionItemsCount = this.transformedSubscriptionData?.length
    const selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts?.size

    if (subscriptionItemsCount <= 0) {
      return ''
    }
    const selectedItemTitle =
      subscriptionItemsCount == 1
        ? 'item'
        : i18nTranslate('mysubscriptions.items', 'items')
    const selectedProducts = `${selectedProductCount} ${i18nTranslate(
      'mysubscriptions.selectedProducts',
      ' selected'
    )}`
    return (
      <div className="show-all-product-details">
        <div className="title-wrap d-flex justify-content-between align-items-center">
          <h4 className="subscription-title">
            {i18nTranslate(
              'mysubscriptions.allSubscribedItems',
              'All Subscribed Items'
            )}
          </h4>
          <div className="items-count">
            <span>{`${subscriptionItemsCount} ${selectedItemTitle}`}</span>
            {selectedProductCount != 0 && (
              <span className="pl-1">({selectedProducts})</span>
            )}
          </div>
        </div>
        <div
          className="subs-product-details-table"
          role="table"
          aria-label="All Subscribed Items">
          <div className="subs-product-scroll-container">
            <div className="subs-product-details-header-row" role="rowgroup">
              {this.renderProductDetailsHeader(
                isCurrentMonthProcessedAndNotSuccessYet
              )}
            </div>
            <div className="product-details-container-row" role="rowgroup">
              {this.transformedSubscriptionData.map(item => {
                return this.renderProductDetails(
                  item,
                  currentMonth,
                  lastOrderProcessedMonth,
                  isCurrentMonthSuccess,
                  isCurrentMonthProcessedAndNotSuccessYet
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const subscriptionProducts =
      subscriptionContainer.showAllSubscriptionResponse
    const navigationUrl = '/'

    if (subscriptionContainer.isPreferenceAPIInProgress) {
      return <></>
    }

    console.log(`subscriptionProducts >>>`, subscriptionProducts)

    return subscriptionProducts?.length > 0 ? (
      <div
        data-testid="subscribed-items-container"
        className="subscribed-items">
        {this.renderProductListView()}
        {this.isDeleteModalEnabled && this.renderDeleteInfoModal()}
      </div>
    ) : (
      <div className="d-flex flex-column align-items-center justify-content-center lostBenefitsBlock">
        <p>
          {i18nTranslate(
            'mysubscriptions.noSubscriptionFound',
            'No Subscriptions Found'
          )}
        </p>
        <Button>
          <LinkWithLocale to={'/'} className="startShopping_text">
            {i18nTranslate(
              'mysubscriptions.startShoppingToday',
              'Start Shopping Today'
            )}
          </LinkWithLocale>
        </Button>
      </div>
    )
  }
}

export default ShowAllProductListView
export { ShowAllProductListView }
